import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, filter, switchMap, take } from "rxjs/operators";
import { SnackBarComponent } from "../components/snack-bar/snack-bar.component";
import { AuthService } from "../services/auth.service";
import { DataService } from "../services/data.service";
import { StorageService } from "../services/storage.service";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    public authService: AuthService,
    public snackBar: MatSnackBar,
    public storageService: StorageService,
    public dataService: DataService,
    private router: Router
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((err) => {
        // console.log(err);
        let error = "";
        if (!window.navigator.onLine) {
          // console.log("no internet connection");
          this.customSnackBar(
            "Network Error! Check your Internet Connection",
            "error"
          );
        }
        if (this.router.url.includes("login")) {
          if ([401].indexOf(err.status) !== -1) {

            // console.log("Err interceptor", err);
            // auto logout if 401 Unauthorized response returned from api
            this.customSnackBar(
              "Permission denied by security module, Redirecting to login page",
              "error"
            );
            this.authService.logout();
            this.router.navigateByUrl("/login");

          }
          else if ([403].indexOf(err.status) !== -1) {

            this.authService.error_data.next(err.error);
            setTimeout(() => {
              //this.router.navigateByUrl("/login");
              this.router.navigate(["/login/invalid-login"]);
            }, 1000);

          }
          else if ([409].indexOf(err.status) !== -1) {
            this.authService.error_data.next(err.error);
            setTimeout(() => {
              //this.router.navigateByUrl("/login");
              this.router.navigate(["/login/invalid-login"]);
            }, 1000);
          }
          else {
            this.authService.error_data.next(err.error);
            this.router.navigate(["/login/invalid-login"]);
          }
        }
        else {
          if ([403].indexOf(err.status) !== -1) {
            this.authService.error_data.next(err.error);
            setTimeout(() => {
              //this.router.navigateByUrl("/login");
              this.router.navigate(["/login/invalid-login"]);
            }, 1000);
          }
          else if ([409].indexOf(err.status) !== -1) {
            this.dataService.customSnackBar(err?.message, 'error')
          }
          else {
            if (err?.error?.message) {
              this.dataService.customSnackBar(err?.error?.message, 'error')
            } else {
              this.dataService.customSnackBar("error occured", 'error')

            }

          }
        }


        // if (err.error !== undefined) {
        //   error = err.error.message;
        // } else if (err.statusText !== undefined) {
        //   error = err.statusText;
        // }
        return throwError(error);
      })
    );
  }

  isRefreshing = false;
  refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.authService.refreshToken().pipe(
        switchMap((res: any) => {
          this.isRefreshing = false;
          this.storageService.setUserData(JSON.stringify(res.data));
          this.refreshTokenSubject.next(res.data.token);
          //this.loaderService.display(false);
          return next.handle(this.authService.addTokenHeader(request, res.data.token));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          //this.loaderService.display(true);
          this.authService.logout();
          return throwError(err);
        })
      );
    }
    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token) => next.handle(this.authService.addTokenHeader(request, token)))
    );
  }









  // Method to toast success/error messages (custom)
  customSnackBar(message: string, type: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: {
        message: message,
        type: type,
      },
      duration: 3000,
    });
  }
}